/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TeamRef } from './teamRef';
import { CompanyRef } from './companyRef';


export interface SwimlaneCompanyTeam { 
    swimLaneName: string;
    swimLaneId: number;
    teamName: TeamRef;
    companyName: CompanyRef;
}

